/**
 * Rating (starts) component
 *
 * ## Ussage
 *
 * <rating [value]="4"></rating>
 *
 * ## Output sample
 * <rating [value]="3.5">
 *   <i class="rate-full"></i>
 *   <i class="rate-full"></i>
 *   <i class="rate-full"></i>
 *   <i class="rate-half"></i>
 *   <i class="rate-empty"></i>
 * </rating>
 *
 */

import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import range from 'lodash-es/range';
import { UiComponent } from '../ui.component';

@Directive()
export class RatingComponentDef extends UiComponent implements OnChanges {
    /**
     * Value to present
     */
    @Input()
    value?: number;

    /**
     * Max rating
     */
    @Input()
    max = 5;

    /**
     * Last item with full star
     */
    maxFull = 0;

    /**
     * Last item with half star
     */
    maxHalf = 0;

    /**
     * Numbers from 1 to max
     */
    items?: number[];

    override ngOnChanges(changes: SimpleChanges): void {
        if (!this.items || this.items.length !== this.max) {
            this.items = range(this.max);
        }

        const value = this.value || 0;

        // max index with full rate
        this.maxFull = Math.floor(value + 0.25);

        // max index with half rate
        this.maxHalf = Math.ceil(value - 0.249);

        super.ngOnChanges(changes);
    }
}
